import "./blogCard.css";
import { Link } from "react-router-dom";
import { formatDate } from "../../../utils/formatDate";
import imgPlaceholder from "../../../assets/logo/green-v.png";
import { urlFor } from "../../../utils/sanityImgBuilder";

export const BlogCard = ({ posts }) => {
  return (
    <div className="blog-card-container">
      {posts.length > 0 ? (
        posts.map((blogposts) => {
          const thumbnail = blogposts.mainImage
            ? urlFor(blogposts.mainImage).url()
            : imgPlaceholder;
          return (
            <Link
              className="blog-card-item"
              to={`/blogg/${blogposts.slug}`}
              key={blogposts.id}
              aria-label={`Länk till blogginlägget: ${
                blogposts.title
              }. skrivet den ${formatDate(blogposts.date)}`}
            >
              {thumbnail && (
                <img
                  src={thumbnail}
                  alt={blogposts.mainImage?.alt || blogposts.title}
                  className="blog-card-thumbnail"
                  height={380}
                  width={450}
                />
              )}
              <h3 aria-hidden="true" className="blog-card-title">
                {blogposts.title}
              </h3>
              <b>{formatDate(blogposts.date)}</b>
            </Link>
          );
        })
      ) : (
        <p>Inga blogginlägg att visa just nu.</p>
      )}
    </div>
  );
};
